import { GamepadRoundOutlineIcon } from './GamepadRoundOutlineIcon';

/**
 * author: Haley Halcyon
 * id 808C141C-877E-49D3-93D6-A69F985A7881
 * name gamepad-round-outline
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gamepad-round-outline.svg
 * tags
 * - Gaming / RPG 
 */
export const ControllerRoundOutlineIcon = GamepadRoundOutlineIcon;
export default ControllerRoundOutlineIcon